import { isNullable } from "@/types/isNullable";

interface OGPPaymentsProps {
  title: string;
  description: string;
  image?: string;
  type?: string;
  keyword?: Array<string>;
}

export function OGPPayments({
  title,
  description,
  image,
  type,
  keyword,
}: OGPPaymentsProps): JSX.Element {
  return (
    <>
      <meta name="description" content={description} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={`${title} | OneFootball`} />
      <meta property="og:description" content={description} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="onefootball.com" />
      <meta name="twitter:title" content={`${title} | OneFootball`} />
      <meta name="twitter:description" content={description} />
      {!isNullable(image) && <meta property="og:image" content={image} />}
      {!isNullable(type) && <meta property="og:type" content={type} />}
      {!isNullable(keyword) && keyword.length > 0 && (
        <meta name="keywords" content={keyword.join(", ")} />
      )}
    </>
  );
}
